import { Box, Typography } from "@mui/material";
import React, { useState } from "react";

import { Abc, HelpOutline } from "@mui/icons-material";
import Prequal from "./Prequal";
import DealerLicense from "./DealerLicense";
import AccordianUtils from "../../../../../../utils/accordian";
import { SalesAidsStyles } from "../../tabs/SalesAidsStyles";

const Integrations = ({ data, edit }) => {
  const [expandedIndex, setExpandedIndex] = useState(0);

  const PrequalService = data?.serviceId?.find((item) => item.service_id === 4);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        p: 2,
        gap: 1,
      }}
    >
      <Typography variant="h6">Integration Types / Patners</Typography>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "scroll",
          height: "100%",
        }}
      >
        <AccordianUtils
          index={0}
          expandedIndex={expandedIndex}
          setExpandedIndex={setExpandedIndex}
          Text={"PreQualifications"}
          icon={<Abc sx={SalesAidsStyles.abcIcon} />}
          content={<Prequal service={PrequalService} />}
        />
        <AccordianUtils
          index={1}
          expandedIndex={expandedIndex}
          setExpandedIndex={setExpandedIndex}
          Text={"Driver's License"}
          icon={<HelpOutline sx={SalesAidsStyles.abcIcon} />}
          content={<DealerLicense />}
        />
        <AccordianUtils
          index={2}
          expandedIndex={expandedIndex}
          setExpandedIndex={setExpandedIndex}
          Text={"Dealer Service Providers"}
          icon={<HelpOutline sx={SalesAidsStyles.abcIcon} />}
        />
      </Box>
    </Box>
  );
};

export default Integrations;
